import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => !!settings?.should_remove_select_keyword_from_address_line_4,
);
